import React, { VFC } from 'react';
import { View, StyleSheet } from 'react-native';
import { Colors, getRadius, getSpacing, Text } from '@rahtab/ui';

const OrderStatus: VFC<OrderStatusProps> = ({ status, statusCode }) => {
  return (
    <View style={StyleSheet.flatten([styles.container, backgroundColors[statusCode]])}>
      <Text variant="subtitle" margin="none" color={'white'}>
        {status}
      </Text>
    </View>
  );
};

export default OrderStatus;

const styles = StyleSheet.create({
  container: {
    borderRadius: getRadius(),
    paddingHorizontal: getSpacing(),
    paddingVertical: getSpacing(0.5),
  },
});
const backgroundColors = StyleSheet.create({
  '1': {
    backgroundColor: Colors.primary,
  },
  '2': {
    backgroundColor: Colors.green,
  },
  '3': {
    backgroundColor: Colors.secondary,
  },
});

interface OrderStatusProps {
  status: string;
  statusCode: '1' | '2' | '3';
}
